import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';
import { SalesOrder } from '@/hooks/api/models';

/**
 * 1270. 受注案件フェーズ更新
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/update_phase
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  team_sales_order_phase_id: number;
};
const updateSalesOrderPhase = (props: Props): Promise<SalesOrder> => {
  return axios.put(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/update_phase`, props);
};

export const useUpdateSalesOrderPhase = () => {
  return useMutation({
    mutationFn: updateSalesOrderPhase,
  });
};
